import { render } from "./bindMobile.vue?vue&type=template&id=86f41210&scoped=true"
import script from "./bindMobile.vue?vue&type=script&lang=js"
export * from "./bindMobile.vue?vue&type=script&lang=js"

import "./bindMobile.vue?vue&type=style&index=0&id=86f41210&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f41210"]])

export default __exports__